import { firstActivePrice } from './getActivePrices';

/**
 * The product's display price — the first active price's amount/currency,
 * falling back to the legacy product-level scalars for products not yet
 * backfilled with prices[].
 */
// TODO(M14): drop the legacy product.price/currency fallback once the prices[] backfill migration has run
export default function getDisplayPrice(product) {
  const price = firstActivePrice(product);
  return {
    amount: price?.amount ?? product?.price,
    currency: price?.currency ?? product?.currency,
  };
}
